import {DeepLink} from './deepLink';

export const deepLink = new DeepLink();
